import ScopedBlogList from '@/components/blog/scoped-blog-list';
import PremiumGate from '@/components/premium/PremiumGate.tsx';
import { ROUTES } from '@/config/routes';
import { clubSidebar } from '@/config/sidebarConfig';
import { useAuthStore } from '@/stores/auth-store';
import { isClubProActive } from '@shared';

export default function ClubBlog() {
  const user = useAuthStore(s => s.user);
  const clubId = user?.clubId;
  const isProActive = isClubProActive(user?.club?.clubPlan, user?.club?.subscriptionStatus);
  return (
    <PremiumGate
      isAllowed={isProActive}
      title='Blog publique (Pro)'
      description='Rédigez des articles et publiez sur votre profil public vos dernières actualités.'
      ctaLabel='Voir l’abonnement'
      ctaTo='/club/settings?tab=subscription'
    >
      <ScopedBlogList
        sidebarConfig={clubSidebar}
        createRoute={ROUTES.CLUB_BLOG_CREATE}
        editRouteBase='/club/blog'
        scopeParams={clubId ? { clubId } : undefined}
        subtitle='Articles de votre club'
      />
    </PremiumGate>
  );
}
